// extracted by mini-css-extract-plugin
export default {"text":"TableText_text__upFeN","bold":"TableText_bold__wAGN0","light":"TableText_light__7vCmJ"};